<template>
    <div
        v-bind="$attrs"
        @click="tryOpenModal"
        class="app-modal-trigger"
        ref="dropdownButtonRef"
    >
        <img
            class="border border-gray-100 shadow-md rounded-full w-"
            src="/default-images/icons/play.png"
            alt="Select Template"
        />
    </div>
    <div
        ref="dropdownMenuRef"
        v-show="state.isDropdownMenuOpen"
        class="bg-white shadow-lg rounded text-sm z-[100000]"
    >
        <div
            class="py-2 px-3 my-1 hover:bg-gray-100 cursor-pointer"
            @click="handleAction({ action: 'play' })"
        >
            Load Play...
        </div>
        <div
            class="py-2 px-3 my-1 hover:bg-gray-100 cursor-pointer"
            @click="handleAction({ action: 'template' })"
        >
            Load Template...
        </div>
    </div>
    <ModalCustom
        :is-open="state.isTemplateModalOpen"
        @close="tryCloseModal"
        z-index="1003"
    >
        <header class="flex items-center mb-4">
            <button
                v-if="state.activeTemplateGroup"
                @click="state.activeTemplateGroup = null"
                class="
                    w-10
                    h-10
                    flex
                    items-center
                    justify-center
                    bg-white
                    rounded-full
                    text-black
                    flex-grow-0 flex-shrink-0
                "
            >
                <ion-icon name="arrow-back-outline"></ion-icon>
            </button>
            <h3 class="mr-12">{{ loadTemplateTitle }}</h3>
            <button
                type="button"
                class="rounded-md ml-auto leading-[0] p-1 hover:bg-gray-100"
                @click="
                    state.isTemplateModalOpen = false;
                    state.activeTemplateGroup = null;
                "
            >
                <ion-icon name="close"></ion-icon>
            </button>
        </header>
        <ul class="block" v-if="!state.activeTemplateGroup">
            <li
                class="block my-4"
                v-for="templateGroup in state.templateGroups"
                :key="templateGroup.playbook_id"
            >
                <button
                    class="
                        block
                        w-full
                        py-2
                        px-4
                        text-left
                        bg-gray-100
                        rounded-md
                        hover:bg-primary hover:bg-opacity-10
                    "
                    @click="state.activeTemplateGroup = templateGroup"
                    type="button"
                >
                    {{ templateGroup.playbook_title }}
                </button>
            </li>
        </ul>
        <ul class="block" v-if="state.activeTemplateGroup">
            <li
                class="block my-4"
                v-for="template in state.activeTemplateGroup.plays"
                :key="template.play_id"
            >
                <button
                    class="
                        block
                        w-full
                        py-2
                        px-4
                        text-left
                        bg-gray-100
                        rounded-md
                        hover:bg-primary hover:bg-opacity-10
                    "
                    @click="loadTemplate(template)"
                    type="button"
                >
                    {{ template.play_name }}
                </button>
            </li>
        </ul>
    </ModalCustom>

    <ModalCustom
        :is-open="state.isPlaybookModalOpen"
        @close="tryCloseModal"
        z-index="1003"
        title="Load Play"
    >
        <div class="w-[80vw] max-h-[50vh] overflow-y-auto">
            <loading-circle class="m-12" v-if="state.isLoading" />
            <div v-else class="mt-2 p-4 flex gap-4">
                <div
                    class="
                        grid grid-cols-3
                        gap-4
                        lg:grid-cols-4
                        flex-grow flex-shrink
                    "
                >
                    <div
                        v-if="playInActivePlaybook.length === 0"
                        class="col-span-4 self-center"
                    >
                        <div class="text-center text-gray-500">
                            No plays in this playbook
                        </div>
                    </div>
                    <div
                        v-for="play in playInActivePlaybook"
                        class="
                            p-8
                            bg-white
                            shadow-xl
                            rounded-lg
                            border border-gray-200
                            text-center
                            cursor-pointer
                            hover:border-primary
                        "
                        @click="loadPlay(play)"
                        :key="play.id"
                    >
                        <div class="block text-xl">
                            {{ play.play_name }}
                        </div>
                        <div class="mt-2">
                            <img
                                :src="
                                    play.thumbnail_url ??
                                    `${previewUrl}/${play.play_preview}`
                                "
                                alt="Play Thumbnail"
                                class="
                                    bg-white
                                    flex-grow flex-shrink
                                    w-full
                                    rounded-md
                                    my-4
                                    object-contain
                                "
                                :style="{
                                    backgroundImage: `linear-gradient(to bottom, #fffa, #fffa), url('${play.background}')`,
                                    backgroundSize: 'contain',
                                    backgroundRepeat: 'no-repeat',
                                    aspectRatio: 2.07339829981,
                                }"
                                onerror="this.onerror=null;this.src='/default-images/dummy-play.png';this.style.backgroundImage = 'none';"
                            />
                        </div>
                    </div>
                </div>
                <div
                    class="
                        flex-grow-0 flex-shrink-0
                        w-[25%]
                        bg-white
                        rounded-md
                        shadow-md
                        p-4
                    "
                >
                    <h4 class="text-xl font-medium mb-2">Playbooks</h4>
                    <ul>
                        <li
                            class="text-gray-500 p-2 mb-2"
                            v-if="state.playbooks.length === 0"
                        >
                            No Playbooks Found
                        </li>
                        <template v-else>
                            <li
                                class="mb-2 ml-0 p-0"
                                v-for="playbook in state.playbooks"
                            >
                                <button
                                    type="button"
                                    @click="state.activePlaybook = playbook"
                                    class="
                                        block
                                        py-2
                                        px-3
                                        bg-gray-200
                                        rounded-md
                                        hover:text-white hover:bg-primary
                                        w-full
                                    "
                                    :class="{
                                        'bg-primary text-white':
                                            state.activePlaybook
                                                ?.playbook_id ===
                                            playbook.playbook_id,
                                    }"
                                >
                                    {{ playbook.playbook_title }}
                                </button>
                            </li>
                        </template>
                    </ul>
                </div>
            </div>
        </div>
    </ModalCustom>
</template>

<script setup>
import { reactive, ref, computed, onMounted } from "vue";
import ModalCustom from "./ModalCustom.vue";
import { createPopper } from "@popperjs/core";

const dropdownMenuRef = ref(null);
const dropdownButtonRef = ref(null);
const toggleDropdown = (value) => {
    state.isDropdownMenuOpen = value;
    if (value) {
        createPopper(dropdownButtonRef.value, dropdownMenuRef.value, {
            placement: "right",
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [0, 8],
                    },
                },
            ],
        }).forceUpdate();
    }
};

const handleAction = (action) => {
    toggleDropdown(false);
    switch (action.action) {
        case "template":
            state.isTemplateModalOpen = true;
            break;
        case "play":
            state.isPlaybookModalOpen = true;
            break;
    }
};

const props = defineProps([
    "previewUrl",
    "playbookApi",
    "playApi",
    "whiteboardApi",
    "showNewPlayButton",
    "previewUrl",
    "playbookApi",
    "playApi",
    "whiteboardApi",
]);
const emit = defineEmits(["loaded"]);
const state = reactive({
    isTemplateModalOpen: false,
    isPlaybookModalOpen: false,
    isDropdownMenuOpen: false,
    isLoading: false,
    activePlaybook: null,
    playbooks: [],

    activeTemplateGroup: null,
    templateGroups: [],
});

const loadTemplateTitle = computed(() => {
    if (state.activeTemplateGroup) {
        return state.activeTemplateGroup.playbook_title;
    }
    return "Load Template";
});

const playInActivePlaybook = computed(() => {
    return state.activePlaybook?.plays ?? [];
});

const tryCloseModal = () => {
    state.isTemplateModalOpen = false;
    state.isPlaybookModalOpen = false;
};

async function tryOpenModal() {
    if (props.playApi) {
        toggleDropdown(!state.isDropdownMenuOpen);
        return;
    }
    state.isTemplateModalOpen = true;
}

async function loadTemplate(template) {
    const dataTemplate = await axios.get("/plays/get-play-data", {
        params: {
            play_id: template.play_id,
        },
    });
    emit("loaded", {
        data: {
            playJson: JSON.parse(dataTemplate.data.play_json),
            background: dataTemplate.data.background,
        },
    });
    state.activeTemplateGroup = null;
    tryCloseModal();
}

async function refreshData() {
    const code = new URLSearchParams(window.location.search).get("code");
    const teamId = new URLSearchParams(window.location.search).get("teamId");

    state.templateGroups = (
        await axios.get(props.playbookApi, {
            params: {
                code,
                teamId,
                isTemplate: 1,
            },
        })
    ).data;

    state.playbooks = (
        await axios.get(props.playbookApi, {
            params: {
                code,
                teamId,
            },
        })
    ).data;
    state.activePlaybook = state.playbooks[0];
}

onMounted(() => {
    refreshData();
});

const loadPlay = async (selectedPlay) => {
    if (!selectedPlay) {
        state.isPlaybookModalOpen = false;
        return;
    }

    const dataPlay = await axios.get("/plays/get-play-data", {
        params: {
            play_id: selectedPlay.play_id,
        },
    });
    const playJson = JSON.parse(dataPlay.data.play_json);
    state.isLoading = true;
    emit("loaded", {
        action: "play",
        data: {
            playJson,
        },
    });
    state.isLoading = false;
    state.isPlaybookModalOpen = false;
};
</script>

<style scoped>
.app-modal-trigger {
    cursor: pointer;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
    padding: 8px;
    border: 1px solid #d1d5db;
    transition: all 0.2s ease-in-out;
    opacity: 0.5;
}

.app-modal-trigger img {
    width: 100%;
    height: 100%;
}

.app-modal-trigger:hover {
    transform: scale(1.05);
    background-color: #f9fafb;
    opacity: 1;
}
</style>
